import type { Theme } from '@mui/material';

import {
  getAccentColor,
  getAccentShade,
  isGradientEnabled,
} from 'src/theme/themeConfig';

export const brandBackground = (theme: Theme) => {
  const palette = theme.colors[getAccentColor()];
  const mainColor = palette[getAccentShade()];

  return isGradientEnabled()
    ? `linear-gradient(282deg, ${mainColor} 56%, ${palette[50]} 120%)`
    : mainColor;
};
